import { render, staticRenderFns } from "./TodoCategorySettings.vue?vue&type=template&id=6af3cb24&scoped=true"
import script from "./TodoCategorySettings.vue?vue&type=script&lang=js"
export * from "./TodoCategorySettings.vue?vue&type=script&lang=js"
import style0 from "./TodoCategorySettings.vue?vue&type=style&index=0&id=6af3cb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3cb24",
  null
  
)

export default component.exports